import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TESTIMONIALS } from '@/lib/data';

export const Testimonials = () => {
    const [idx, setIdx] = useState(0);

    useEffect(() => {
        const t = setInterval(() => setIdx((i) => (i + 1) % TESTIMONIALS.length), 6500);
        return () => clearInterval(t);
    }, []);

    const t = TESTIMONIALS[idx];

    return (
        <section
            data-testid="testimonials-section"
            className="relative bg-ink py-28 md:py-36 overflow-hidden"
        >
            <div className="absolute inset-0 opacity-[0.04]">
                <img
                    src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=2000&q=60"
                    alt=""
                    className="w-full h-full object-cover"
                />
            </div>

            <div className="relative px-6 md:px-12 lg:px-16 max-w-5xl mx-auto text-center">
                <p className="text-xs uppercase tracking-[0.4em] text-gold mb-10">
                    Notes from the Cast
                </p>

                <AnimatePresence mode="wait">
                    <motion.blockquote
                        key={t.who}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.8 }}
                        data-testid={`testimonial-${idx}`}
                    >
                        <p className="font-serif text-bone text-2xl sm:text-3xl lg:text-5xl tracking-tighter font-light leading-[1.2] italic">
                            “{t.quote}”
                        </p>
                        <footer className="mt-10 text-[11px] uppercase tracking-[0.3em] text-bone-dim">
                            <span className="text-bone">{t.who}</span> · {t.where}
                        </footer>
                    </motion.blockquote>
                </AnimatePresence>

                <div className="mt-12 flex justify-center gap-2">
                    {TESTIMONIALS.map((_, i) => (
                        <button
                            key={i}
                            data-testid={`testimonial-dot-${i}`}
                            onClick={() => setIdx(i)}
                            className={`h-px transition-all duration-500 ${
                                i === idx ? 'w-12 bg-gold' : 'w-6 bg-bone-dim/40'
                            }`}
                            aria-label={`Show testimonial ${i + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};
